import React from 'react'
import './order-mall.scss'
import useBemClass from '@/utils/hooks/useBEMClass'
import { Expaned, Row } from '@/components/layout/layout'
import { DatePicker } from 'antd'
import SearchInput from '@/components/search-input/search-input'
import MallOrderTable from './order-list/order-table/order-table'
import MallOrderFilter from './order-filter/order-filter'
import MallOrderList from './order-list/order-list/order-list'
import { mallOrderFilterStore } from './order-filter/filter-store'
import { observer } from 'mobx-react'
import { showLayer } from '@/utils/layer'

const OrderMall = () => {
    const getCls = useBemClass('order-mall')

    return (
        <Expaned className={getCls()}>
            <div className={getCls('header')}>
                <div className="time-picker">
                    <DatePicker.RangePicker
                        dateRender={current => (
                            <div
                                className="ant-picker-cell-inner"
                                style={{
                                    borderRadius: '50%',
                                }}
                            >
                                {current.date()}
                            </div>
                        )}
                        onChange={(monent, dateString) => {
                            mallOrderFilterStore.setDate(dateString[0] ? dateString : [])
                        }}
                        suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                    />
                </div>
                <div
                    style={{
                        width: '340px',
                        marginLeft: '10px',
                    }}
                >
                    <SearchInput
                        placeholder="请输入订单编号/用户昵称/手机号"
                        onSearch={keyWord => {
                            mallOrderFilterStore.setkeyWord(keyWord)
                        }}
                        onDelete={() => {}}
                    ></SearchInput>
                </div>
                <div
                    className={getCls('filter')}
                    data-cursor-pointer
                    onClick={() => {
                        showLayer(<MallOrderFilter />)
                    }}
                    style={{
                        color: !mallOrderFilterStore.filterTxt ? '#333' : '#14cc9b',
                    }}
                >
                    <i className="iconfont icon6shaixuan-20" data-font-size-20 />
                    <span data-margin-left-8>筛选</span>
                </div>
            </div>
            {(mallOrderFilterStore.filterTxt || mallOrderFilterStore.keyWord) && (
                <Row className={getCls('searchBox')}>
                    <Row>
                        {mallOrderFilterStore.keyWord && (
                            <div>
                                搜索：
                                <span data-font-weight-600 className="them-color" data-padding-h-8>
                                    {mallOrderFilterStore.keyWord}
                                </span>
                            </div>
                        )}
                        {mallOrderFilterStore.filterTxt && (
                            <div>
                                筛选：
                                <span data-font-weight-600 className="them-color" data-padding-h-8>
                                    {mallOrderFilterStore.filterTxt}
                                </span>
                            </div>
                        )}
                    </Row>
                    <div
                        className={getCls('delete')}
                        onClick={() => {
                            mallOrderFilterStore.setkeyWord('')
                            mallOrderFilterStore.resetFilterMap()
                        }}
                    >
                        <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                    </div>
                </Row>
            )}
            <Expaned data-column data-overflow-hidden className={getCls('content')}>
                <MallOrderList />
                <MallOrderTable />
            </Expaned>
        </Expaned>
    )
}

export default observer(OrderMall)
